import { mergeObjectTypes } from '../cacheHelpers';

const PerUnitCbm = {
  merge: mergeObjectTypes
};

export default PerUnitCbm;
